// A forecast's predicted buckets follow the actual rows in the response, each
// marked predicted: true (actual rows have no such key)
const splitPredictedRows = (
  response: MetricsResponse,
): { actual: MetricsResponse; predicted: MetricsResponse } => ({
  actual: response.filter((row) => row.predicted !== true),
  predicted: response.filter((row) => row.predicted === true),
});

export default splitPredictedRows;
